import React, { useEffect, useRef, useState } from 'react'
import { useTheme } from '@/context/ThemeContext'

type Props = {
  flash: 'connected' | 'error'
  service: string
  message?: string
  onDismiss: () => void
}

const FlashBanner: React.FC<Props> = ({ flash, service, message, onDismiss }) => {
  const { currentTheme: t } = useTheme()
  const [fading, setFading] = useState(false)
  const dismissRef = useRef(onDismiss)
  dismissRef.current = onDismiss

  const isOk = flash === 'connected'

  // 4s before it clears, matching the toast duration used elsewhere.
  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), 3500)
    const removeTimer = setTimeout(() => dismissRef.current(), 4000)
    return () => { clearTimeout(fadeTimer); clearTimeout(removeTimer) }
  }, [])
  return (
    <div
      className="flex items-center justify-between px-4 py-3 rounded-lg mb-3 text-sm"
      style={{
        backgroundColor: isOk ? t.successBackground : t.errorBackground,
        color: isOk ? t.successText : t.errorText,
        border: `1px solid ${isOk ? t.successText : t.errorText}`,
        opacity: fading ? 0 : 1,
        transform: fading ? 'translateY(-4px)' : 'translateY(0)',
        transition: 'opacity 0.5s ease, transform 0.5s ease',
      }}
      role="alert"
    >
      <span>
        {message ?? (isOk ? `${service} connected successfully.` : `${service} connection failed. Please try again.`)}
      </span>
      <button
        onClick={onDismiss}
        className="ml-4 text-xs opacity-70 hover:opacity-100 transition-opacity shrink-0"
        aria-label="Dismiss"
      >
        Dismiss
      </button>
    </div>
  )
}

export default React.memo(FlashBanner)
